import React from 'react';
import cx from 'classnames';
import { Typography } from '@navi/web-ui/lib/primitives';
import VerticalSeperator from '@cp/src/components/VerticalSeperator';
import { PreAuditValuesProps } from '../../interface';
import { SOURCE_ICON_MAP } from '../../utils';
import PreAuditMoreButton from './PreAuditMoreButton';

const CHAR_LIMIT = 40;

const PreAuditValues: React.FC<PreAuditValuesProps> = ({ values, className, sourceOfValues }) => {
  if (!values.length) {
    return null;
  }

  let charsUsed = 0;
  let visibleCount = 0;
  for (const value of values) {
    const len = value.label.length;
    if (visibleCount > 0 && charsUsed + len > CHAR_LIMIT) break;
    charsUsed += len;
    visibleCount++;
    if (charsUsed >= CHAR_LIMIT) break;
  }

  const displayedValues = values.slice(0, visibleCount);
  const hiddenValues = values.slice(visibleCount);
  const hasMoreItems = hiddenValues.length > 0;

  return (
    <div
      className={cx(
        'm-3 p-2 bg-[var(--pale-yellow)] rounded-md flex flex-row items-center gap-2 min-w-0',
        className
      )}
    >
      <span className="flex-shrink-0 flex items-center">{SOURCE_ICON_MAP[sourceOfValues]}</span>
      <div className="flex flex-row items-center gap-2 flex-1 min-w-0 overflow-hidden">
        {displayedValues.map((value, index) => (
          <div key={value.id} className="flex items-center gap-2 flex-shrink-0 whitespace-nowrap">
            <Typography variant="p3" color="var(--grayscale-2)">
              {value.label}
            </Typography>
            {(index < displayedValues.length - 1 || hasMoreItems) && (
              <VerticalSeperator height="17px" color="var(--grayscale-border-1)" />
            )}
          </div>
        ))}
        {hasMoreItems && (
          <span className="flex-shrink-0">
            <PreAuditMoreButton hiddenValues={hiddenValues} />
          </span>
        )}
      </div>
    </div>
  );
};

export default PreAuditValues;
